<template>
  <div class="min-h-screens font-sans transition-colors duration-300">
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100 container mx-auto px-6"
    >
      <section class="py-8 dark:bg-slate-900/50">
        <navi-bar :ptitle="l" :dtitle="pdata.pTitle" />
        <div
          class="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
        >
          <!-- src="@/assets/product/Electric Insulation Silicone Rubber.jpg" -->
          <div class="relative overflow-hidden rounded-lg aspect-square px-16">
            <img
              alt="Factory"
              class="w-full h-full object-contain"
              :src="imgUrl"
            />
          </div>
          <div class="space-y-6">
            <h2 class="text-3xl font-bold text-slate-900 dark:text-white">
              {{ pdata.pTitle }}
            </h2>
            <div class="prose prose-slate dark:prose-invert">
              <p class="text-slate-600 dark:text-slate-400">
                {{ pdata.desc }}
              </p>
            </div>
            <div>
              <h2 class="text-md font-bold text-slate-900 dark:text-white mb-4">
                Key Feature
              </h2>
              <ul>
                <li
                  class="text-slate-600"
                  v-for="(item, index) in pdata.feature"
                  :key="index"
                >
                  <i
                    class="fa-solid fa-circle text-[10px] mr-[6px] text-[#00479d]"
                  ></i>
                  {{ item }}
                </li>
              </ul>
            </div>
            <div>
              <span class="font-bold">Application:</span>
              {{ pdata.application }}
            </div>
            <div class="flex justify-center mt-6">
              <button
                class="inline-flex items-center gap-2 border border-primary text-primary px-8 py-3 rounded-full hover:bg-primary hover:text-white transition-all font-semibold"
                @click="naviContactUs"
              >
                Contact us
                <i class="fa-solid fa-envelope"></i>
              </button>
            </div>
          </div>
        </div>
        <div>
          <div
            class="flex flex-col items-center mt-32"
            v-for="(tab, tindex) in pdata.tab"
            :key="tindex"
          >
            <h2 class="text-3xl text-slate-900 dark:text-white">
              {{ tab.title }}
            </h2>
            <p-tab :config="tab" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import data from './pdata/pdata.json'
import PTab from './PTab.vue'
import NaviBar from './NaviBar'
export default {
  name: 'Details',
  components: {
    PTab,
    NaviBar
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path !== '/products-details') {
          return
        }
        if (!from) {
          this.name = this.$route.query.n
          this.l = this.$route.query.l
          this.loadProductAbout()
          return
        }
        if (from.name === 'ProductsDetails' && to.query === from.query) {
          return
        }
        this.name = this.$route.query.n
        this.l = this.$route.query.l
        this.loadProductAbout()
      },
      deep: true, // 深度监听
      immediate: true // 立即执行一次
    }
  },
  data() {
    return {
      imgUrl: '',
      name: '',
      type: '',
      l: '',
      data: data,
      pdata: {}
    }
  },
  mounted() {
    this.loadProductAbout()
    // this.loadPData()
  },
  methods: {
    loadProductAbout() {
      this.name = this.$route.query.n
      // console.log(this.name)
      this.type = this.$route.query.t
      this.imgUrl = require(`@/assets/product/${this.name}.${this.type}`)
      this.loadPData()
    },
    loadPData() {
      this.pdata = this.data[this.name]
      // console.log(JSON.stringify(this.pdata))
      // console.log('====' + JSON.stringify(this.data[this.name]))
    },
    naviContactUs() {
      this.$router.push({
        path: '/contact'
      })
    }
  }
}
</script>

<style scoped>
/* ul {
  list-style-type: circle;
  color: #00479d;
} */
</style>



// WEBPACK FOOTER //
// src/page/Products/Details.vue